var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25012 17.1665C3.25012 17.5807 2.91434 17.9165 2.50012 17.9165C2.08591 17.9165 1.75012 17.5807 1.75012 17.1665L1.75012 3.83316C1.75012 3.41895 2.08591 3.08316 2.50012 3.08316C2.91434 3.08316 3.25012 3.41895 3.25012 3.83316L3.25012 17.1665ZM11.3636 16.0302C11.6565 15.7374 11.6565 15.2625 11.3636 14.9696L7.64417 11.2501H17.4999C17.9141 11.2501 18.2499 10.9143 18.2499 10.5001C18.2499 10.0859 17.9141 9.75012 17.4999 9.75012H7.64376L11.3636 6.03024C11.6565 5.73735 11.6565 5.26248 11.3636 4.96958C11.0707 4.67669 10.5959 4.67669 10.303 4.96958L5.30298 9.96958L4.77265 10.4999L5.29045 11.0177C5.29864 11.0263 5.30703 11.0347 5.31562 11.0429L10.303 16.0302C10.5959 16.3231 11.0707 16.3231 11.3636 16.0302Z",
    fill: "#9CA3AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarArrow);
export default __webpack_public_path__ + "static/media/sidebar-arrow.768ab1076dc3e66d813d151ac3944009.svg";
export { ForwardRef as ReactComponent };